import { CardContent } from '@mui/material';

import { CardContentTitle } from './CardContentTitle';
import { CardContentWithCopyIcon } from './CardContentWithCopyIcon';
import { CommonCardContent } from './CommonCardContent';

type UserProfileIdentitiesCardContentTemplateProps = {
    content: string;
    description?: string;
    title: string;
    useCopyIcon?: boolean;
}

const CARD_CONTENT_INLINE_STYLES = {
    padding: '0 0 0 32px',
    marginBottom: '8px'
};

export function UserProfileIdentitiesCardContentTemplate({
    content,
    description,
    title,
    useCopyIcon = false
}: Readonly<UserProfileIdentitiesCardContentTemplateProps>) {
    const cardContentToRender = useCopyIcon
        ? <CardContentWithCopyIcon content={content}/>
        : <CommonCardContent content={content}/>;

    return (
        <CardContent sx={CARD_CONTENT_INLINE_STYLES}>
            <CardContentTitle description={description} title={title} />
            {cardContentToRender}
        </CardContent>
    );
}
